/**
 * Capture + replay a subscription promo code embedded in a venue URL
 * (Fenton 2026-10-03 Silva Bumpa goodwill flow). The push notification
 * links users to `https://theloveinn.com/?code=SORRYLOVEINN`, we stash
 * the code in localStorage so it survives sign-in, membership-page
 * navigation, and Stripe return hops, then pass it on the next
 * subscribe-checkout call.
 *
 * Mirrors web/src/lib/referral.ts (same pattern Issy adopted for the
 * referral programme).
 */
const STORAGE_KEY = "pending_subscribe_promo_code";

export function captureSubscribePromoCode() {
  const code = new URLSearchParams(window.location.search).get("code");
  if (code) {
    localStorage.setItem(STORAGE_KEY, code.toUpperCase());
    console.log("[subscribe-promo] captured from URL:", code.toUpperCase());
  }
}

export function peekSubscribePromoCode(): string | undefined {
  return localStorage.getItem(STORAGE_KEY) ?? undefined;
}

// Non-destructive read, matches referral.ts: an abandoned checkout
// (back button, declined card) keeps the code so the next attempt works.
// Cleared explicitly by clearSubscribePromoCode on the ?subscribed=true
// success redirect.
export function consumeSubscribePromoCode(): string | undefined {
  const code = localStorage.getItem(STORAGE_KEY) ?? undefined;
  if (code) {
    console.log("[subscribe-promo] sending to checkout:", code);
  }
  return code;
}

export function clearSubscribePromoCode() {
  const code = localStorage.getItem(STORAGE_KEY);
  if (code) {
    localStorage.removeItem(STORAGE_KEY);
    console.log("[subscribe-promo] cleared after successful subscription:", code);
  }
}
